module.exports = __webpack_public_path__ + "static/ali-pic-24c109032fef9faae1fff173aad9ce5d.png";